<template>
    <aside id="sidebar" class="sidebar">
        <ul class="sidebar-nav" id="sidebar-nav">

            <!-- History Telemteri -->
            <li class="nav-item">
                <router-link class="nav-link" to="/index-kualitas-air" inactive-class="collapsed">
                    <img src="../assets/icon/sarpras-dashboard.png" alt="" style="width: 30px; padding-right: 5px;">
                    <span>Overview</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/index-kualitas-air/citarum" inactive-class="collapsed">
                    <i class="bi bi-circle"></i>
                    <span>Citarum</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/index-kualitas-air/bekasi" inactive-class="collapsed">
                    <i class="bi bi-circle"></i>
                    <span>Bekasi</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/index-kualitas-air/induk tarum barat" inactive-class="collapsed">
                    <i class="bi bi-circle"></i>
                    <span>Induk Tarum Barat</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/index-kualitas-air/sungai lain" inactive-class="collapsed">
                    <i class="bi bi-circle"></i>
                    <span>Sungai Lain</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/index-kualitas-air/induk tarum utara" inactive-class="collapsed">
                    <i class="bi bi-circle"></i>
                    <span>Induk Tarum Utara</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/index-kualitas-air/waduk" inactive-class="collapsed">
                    <i class="bi bi-circle"></i>
                    <span>Waduk</span>
                </router-link>
            </li>
        </ul>
    </aside>
</template>

<script>
    export default {
        name: 'SidebarSpatial',
    }
</script>